<header class="navbar">
  <section
    class="navbar-section action-navbar"
  >
    <h3 class="section-title">
      {{ title | translate }}
    </h3>
    <div class="subtitle-holder" *ngIf="subtitle != null && subtitle != ''">
      {{ subtitle | translate }}
    </div>
  </section>
  <section class="navbar-section">
    <ng-container *ngFor="let item of actionbarItemsThis">
      <a
        (click)="onItemClicked(item)"
        class="btn btn-light"
        *ngIf="shouldShow(item)"
      >
        <span *ngIf="item.iconClass"><i class="{{ item.iconClass }}"></i></span>
        {{ item.btnText | translate }}
      </a>
    </ng-container>
  </section>
</header>
